import React from 'react'

const Datas = [
    {
        id: 1,
        title: "Red Velvet Cake",
        recipe: "Experience a slice of pure elegance with our velvety smooth creation, where vibrant red layers meet creamy vanilla frosting in a celebration of rich, indulgent flavor",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipNi7kUqzQIm9VZY2hmaIO2eryjeJ3j3JmtqjRam=s1360-w1360-h1020"
    },
    {
        id: 2,
        title: "Chocolate truffle cake",
        price: 1000,
        recipe: " Delight in layers of moist chocolate sponge enveloped in smooth ganache, crowned with chocolate shavings for an irresistible symphony of cocoa decadence.",
        img: "https://lh3.googleusercontent.com/p/AF1QipNmGzcgLyGSJlxpPzAP1bcERu9y-tyGKWnPet0Q=s1360-w1360-h1020",
    },
    {
        id: 3,
        title: "rich choclate truffle",
        recipe: "Indulge in the ultimate chocolate experience with our exquisite Chocolate Truffle Cake. Delicately layered with velvety chocolate sponge and enrobed in a luxurious ganache",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipMFR_uaBafb4Lve6fOwSSFkLqEpnrVezE42HhDx=s1360-w1360-h1020",
    },

    {
        id: 4,
        title: "Butterscotch cake ",
        price: 1000,
        recipe: "Savor the luxurious essence of our Butterscotch Cake, where golden caramel flavors intertwine with moist, tender layers. Topped with a luscious butterscotch frosting and adorned with caramel drizzles",
        img: "https://lh3.googleusercontent.com/p/AF1QipOoqRQzChvqCHRcdM3nbpMPOybMzGw9Ya3Y7chN=s1360-w1360-h1020",
    },
    {
        id: 5,
        title: "Rich Chocolate Cream",
        recipe: "Savor the luxurious essence of our Butterscotch Cake, where golden caramel flavors intertwine with moist, tender layers. Topped with a luscious butterscotch frosting and adorned with caramel drizzles",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipNgYZ_-oEgP6yuO-u_z-KNP_Lbx3faZnWm2plQ4=s1360-w1360-h1020",
    },
    {
        id: 6,
        title: "Rich Chocolate Cream",
        recipe: " Immerse yourself in the opulence of traditional Indian flavors with our exquisite Rasgulla Cake. Layers of soft, spongy cake infused with delicate rosewater syrup, nestled between velvety layers of creamy paneer and garnished with golden strands of saffron.",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipP133-m1rnWMcOOuj1hRMqxsg7AjlSRgdzFv71w=s1360-w1360-h1020",
    },
    {
        id: 7,
        title: "Rich Chocolate Cream",
        recipe: "Indulge in a divine symphony of rich cocoa flavors and smooth ganache, crafted to satisfy the deepest cravings for chocolate lovers everywhere.",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipNuuAmZLo8frRkHCohCkTz1FwbGOw5QDpgMvc82=s1360-w1360-h1020",
    },
    {
        id: 8,
        title: "Rich Chocolate Cream",
        recipe: "Indulge in a divine symphony of rich cocoa flavors and smooth ganache with mango fillings and toppings, crafted to satisfy the deepest cravings for chocolate lovers everywhere.",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipM3xyfS-g4dZx8ah1kvKXOEq4oZJnRdfRQSuObz=s1360-w1360-h1020",
    },
    {
        id: 9,
        title: "Rich Chocolate Cream",
        recipe: "Indulge in a divine symphony of rich cocoa flavors and smooth ganache, crafted to satisfy the deepest cravings for chocolate lovers everywhere.",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipMgjwXg2r3zQ_d75BDYME1ydgsUGyNDzvF4gi6U=s1360-w1360-h1020",
    },
    {
        id: 10,
        title: "Rich Chocolate Cream",
        recipe: "Indulge in a divine symphony of rich cocoa flavors and smooth ganache, crafted to satisfy the deepest cravings for chocolate lovers everywhere.",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipO53aQ9ifnyoY7OkHXfEBDnq8q6eCDx3bHgURa9=s1360-w1360-h1020",
    },
    {
        id: 11,
        title: "butterscotch cake",
        recipe: "Indulge in the luxurious flavors of golden caramel and velvety butterscotch, layered between moist cake and finished with a decadent caramel glaze",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipPgq3YnwTFb8EbmRy3sYTg_4HBrWNy1Ast7kiUZ=s1360-w1360-h1020",
    },
    {
        id: 12,
        title: "Rich Chocolate Cream",
        recipe: "Revel in layers of rich butterscotch and decadent red velvet cake, adorned with a caramelized glaze that promises pure indulgence with every forkful.",
        price: 1000,
        img: "https://lh3.googleusercontent.com/p/AF1QipPUDHHMDCzZAx2B_HjxOW_3Se3bR4TU35FkCFpk=s1360-w1360-h1020",
    }

];

export default Datas;

